export default "__VITE_ASSET__ugYlJOtQ__"